import { useEffect } from 'react';
import { deviceSeen } from '../data/api';

const KEY = 'shh.deviceSeen';

/**
 * The shared device tells the server once a day that it is still in use (1.29): parents see
 * "zuletzt aktiv" and can tell real devices from old entries. Best effort – offline or a full
 * storage just means one more call tomorrow.
 */
export function useDeviceSeen(active: boolean, today: string) {
  useEffect(() => {
    if (!active) return;
    try {
      if (localStorage.getItem(KEY) === today) return;
    } catch {
      // no storage (private window): one call per start is still cheap
    }
    void deviceSeen()
      .then(() => {
        try {
          localStorage.setItem(KEY, today);
        } catch {
          // see above
        }
      })
      .catch(() => undefined);
  }, [active, today]);
}
